import { getClientDomain, reportError } from "../utils";

import type { ProductDetailType } from "../types";

export async function getProduct(
  title: string,
  callback: (product: ProductDetailType[]) => void,
  productId?: string
) {
  try {
    const replaceTitle = title.replaceAll("-", " ");
    let selected: ProductDetailType | undefined;
    if (productId) {
      const selectedResponse = await fetch(`${getClientDomain()}/api/get-products-by-id/${encodeURIComponent(productId)}`);
      if (!selectedResponse.ok) throw new Error("Product unavailable");
      selected = await selectedResponse.json();
    }
    let productDetail: ProductDetailType[] = [];
    try {
      const response = await fetch(`${getClientDomain()}/api/get-products-by-title/${encodeURIComponent(replaceTitle)}`);
      if (response.ok) productDetail = await response.json();
    } catch (error) {
      if (!selected) throw error;
    }
    if (selected && !productDetail.some(product => product.id === selected?.id)) productDetail.unshift(selected);
    callback(productDetail);
  } catch (e: unknown) {
    reportError(e as Error, {
      endpoint: "/api/get-products-by-title/" + title,
      method: "GET",
    });
    throw new Error(JSON.stringify(e));
  }
}
